import React from "react";
import {  MDBRow, MDBCol, MDBIcon, MDBBtn , MDBAnimation} from "mdbreact";
import './Services.css';


const FeaturesPage = () => {
  return (
    <section className="my-5 servicessection">
      <h2 className="h1-responsive font-weight-bold text-center my-5">
        Why is it so great?
      </h2>
      <p className="lead grey-text w-responsive text-center mx-auto mb-5">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
        eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
        ad minim veniam.
      </p>

      <MDBRow className="servicesrow">
      {/* <MDBCol md="1"/> */}
        <MDBCol md="4" className="md-0 mb-5">
          <MDBRow>
            <MDBCol lg="2" md="3" size="2" className="featureicon">
            <MDBAnimation reveal type="bounceInUp" count={1} duration="1s">
            <MDBIcon icon="bullhorn" size="2x" className="servicesiconcolor" />
            </MDBAnimation>
            </MDBCol>
            <MDBCol lg="10" md="9" size="10" className="featurecontent">
            <MDBAnimation reveal type="bounceInDown" count={1} duration="1s">
              <h4 className="font-weight-bold ">Marketing</h4>
              <p className="grey-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna
                aliqua. Ut enim ad minim veniam.
              </p>
              <MDBBtn className="servicesbuttoncolor" size="sm">
                Learn more
              </MDBBtn>
              </MDBAnimation>
            </MDBCol>
          </MDBRow>
        </MDBCol>
        <MDBCol md="4" className="md-0 mb-5">
          <MDBRow>
            <MDBCol lg="2" md="3" size="2" className="featureicon">
            <MDBAnimation reveal type="bounceInUp" count={1} duration="1s">
              <MDBIcon icon="cogs" size="2x" className="servicesiconcolor" />
              </MDBAnimation>
            </MDBCol>
            <MDBCol lg="10" md="9" size="10" className="featurecontent">
            <MDBAnimation reveal type="bounceInDown" count={1} duration="1s">
              <h4 className="font-weight-bold">Customization</h4>
              <p className="grey-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna
                aliqua. Ut enim ad minim veniam.
              </p>
              <MDBBtn className="servicesbuttoncolor" size="sm">
                Learn more
              </MDBBtn>
              </MDBAnimation>
            </MDBCol>
          </MDBRow>
        </MDBCol>
        <MDBCol md="4" className="md-0 mb-5">
          <MDBRow>
            <MDBCol lg="2" md="3" size="2" className="featureicon">
            <MDBAnimation reveal type="bounceInUp" count={1} duration="1s">
              <MDBIcon icon="tachometer-alt" size="2x" className="servicesiconcolor" />
              </MDBAnimation>
            </MDBCol>
            <MDBCol lg="10" md="9" size="10" className="featurecontent">
            <MDBAnimation reveal type="bounceInDown" count={1} duration="1s">
              <h4 className="font-weight-bold">Support</h4>
              <p className="grey-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna
                aliqua. Ut enim ad minim veniam.
              </p>
              <MDBBtn className="servicesbuttoncolor" size="sm">
                Learn more
              </MDBBtn>
              </MDBAnimation>
            </MDBCol>
          </MDBRow>
        </MDBCol>
      </MDBRow>

   {/* second row */}


   <MDBRow className="servicesrow">
      {/* <MDBCol md="1"/> */}
        <MDBCol md="4" className="md-0 mb-5">
          <MDBRow>
            <MDBCol lg="2" md="3" size="2" className="featureicon">
            <MDBAnimation reveal type="bounceInUp" count={1} duration="1s">
            <MDBIcon icon="bullhorn" size="2x" className="servicesiconcolor" />
            </MDBAnimation>
            </MDBCol>
            <MDBCol lg="10" md="9" size="10" className="featurecontent">
            <MDBAnimation reveal type="bounceInDown" count={1} duration="1s">
              <h4 className="font-weight-bold ">Marketing</h4>
              <p className="grey-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna
                aliqua. Ut enim ad minim veniam.
              </p>
              <MDBBtn className="servicesbuttoncolor" size="sm">
                Learn more
              </MDBBtn>
              </MDBAnimation>
            </MDBCol>
          </MDBRow>
        </MDBCol>
        <MDBCol md="4" className="md-0 mb-5">
          <MDBRow>
            <MDBCol lg="2" md="3" size="2" className="featureicon">
            <MDBAnimation reveal type="bounceInUp" count={1} duration="1s">
              <MDBIcon icon="cogs" size="2x" className="servicesiconcolor" />
              </MDBAnimation>
            </MDBCol>
            <MDBCol lg="10" md="9" size="10" className="featurecontent">
            <MDBAnimation reveal type="bounceInDown" count={1} duration="1s">
              <h4 className="font-weight-bold">Customization</h4>
              <p className="grey-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna
                aliqua. Ut enim ad minim veniam.
              </p>
              <MDBBtn className="servicesbuttoncolor" size="sm">
                Learn more
              </MDBBtn>
              </MDBAnimation>
            </MDBCol>
          </MDBRow>
        </MDBCol>
        <MDBCol md="4" className="md-0 mb-5">
          <MDBRow>
            <MDBCol lg="2" md="3" size="2" className="featureicon">
            <MDBAnimation reveal type="bounceInUp" count={1} duration="1s">
              <MDBIcon icon="tachometer-alt" size="2x" className="servicesiconcolor" />
              </MDBAnimation>
            </MDBCol>
            <MDBCol lg="10" md="9" size="10" className="featurecontent">
            <MDBAnimation reveal type="bounceInDown" count={1} duration="1s">
              <h4 className="font-weight-bold">Support</h4>
              <p className="grey-text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                do eiusmod tempor incididunt ut labore et dolore magna
                aliqua. Ut enim ad minim veniam.
              </p>
              <MDBBtn className="servicesbuttoncolor" size="sm">
                Learn more
              </MDBBtn>
              </MDBAnimation>
            </MDBCol>
          </MDBRow>
        </MDBCol>
      </MDBRow>
            
    </section>
  );
}

export default FeaturesPage;